export const userTablePageSize = 25;
export const userTablePageNumber = 0;
export const fieldActivityPageSize = 25;
export const fieldActivityPageNumber = 1;
export const projectStartDate = 2019;
export const perPage = [10, 15, 20, 25, 50]
export const allowedRoles = ["65c35943165ed3007dc9cc98", "6099f4e39134283495c4144b", "6638769df970a7d09d4f6b9c", "6638768df970a7d09d4f6b9a", "66387684f970a7d09d4f6b99"]
export const MAX_SELECTABLE_IMAGES = 50
export const FILE_EXTENSION_PATTERN = /\.[^/.]+$/